import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function OneWayForm({ onSubmit }) {
  const [formData, setFormData] = useState({
    name: "",
    date: "",
    price: "",
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = { type: "oneway", ...formData };
    console.log("🚀 Payload sending to backend:", payload);

    try {
      const res = await fetch(
        "https://api.pdf.tajgateways.com/api-v1/users/convert-pdf",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const data = await res.json();
      console.log("Response:", data);

      if (data) {
        toast.success("✅ Form submitted successfully!", {
          position: "top-right",
          autoClose: 3000,
        });
        setTimeout(() => navigate("/"), 3000);
      }

      onSubmit();
    } catch (err) {
      console.error("Error submitting form:", err);
      toast.error("❌ Failed to submit. Please try again.", {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      {/* ✅ Responsive CSS */}
      <style>
        {`
          @media (max-width: 768px) {
            .form-box {
              width: 90% !important;
              padding: 25px 20px !important;
            }
            .form-title {
              font-size: 20px !important;
            }
            input, button {
              font-size: 14px !important;
              padding: 10px !important;
            }
              .dashboard-btn {
              font-size: 12px !important;
              padding: 6px 10px !important;
              top: 20px !important;
              right: 30px !important;
            }
          }

          @media (max-width: 480px) {
            .form-box {
              width: 95% !important;
              padding: 20px 15px !important;
            }
            .form-title {
              font-size: 18px !important;
            }
            input, button {
              font-size: 13px !important;
              padding: 9px !important;
            }
            .dashboard-btn {
              font-size: 12px !important;
              padding: 6px 10px !important;
              top: 20px !important;
              right: 20px !important;
            }
          }
        `}
      </style>

      <ToastContainer />

      {/* Dashboard Button */}
      <div
        className="dashboard-btn"
        style={{
          position: "absolute",
          top: "20px",
          right: "20px",
        }}
      >
        <button
          type="button"
          style={styles.dashboardBtn}
          onClick={() => navigate("/")}
        >
          📊 Dashboard
        </button>
      </div>

      {/* Form */}
      <form
        style={styles.form}
        className="form-box"
        onSubmit={handleSubmit}
      >
        <h3 style={styles.title} className="form-title">
          ✈️ One Way Ticket
        </h3>

        <input
          style={styles.input}
          name="name"
          placeholder="Passenger Name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <label style={styles.label}>Departure date:</label>
        <input
          style={styles.input}
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          required
        />

        <input
          style={styles.input}
          type="number"
          name="price"
          placeholder="Price (INR)"
          value={formData.price}
          onChange={handleChange}
          required
        />

        <button style={styles.button} type="submit" disabled={loading}>
          {loading ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <div style={styles.loader}></div>
              Submitting...
            </div>
          ) : (
            "Submit"
          )}
        </button>
      </form>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    position: "relative",
    padding: "20px",
  },
  form: {
    background: "#ffffff",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
    width: "350px",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    transition: "0.3s ease",
    position: "relative",
    top: "100px",
  },
  label: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#2c3e50",
    marginBottom: "-10px",
    marginLeft: "5px",
  },
  title: {
    marginBottom: "10px",
    color: "#2c3e50",
    textAlign: "center",
    fontSize: "22px",
    fontWeight: "600",
  },
  dashboardBtn: {
    background: "#3498db",
    color: "#fff",
    padding: "8px 14px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    transition: "0.3s",
  },
  input: {
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "14px",
    outline: "none",
    transition: "0.3s",
    color: "#000",
    width: "100%",
    boxSizing: "border-box",
  },
  button: {
    background: "#3498db",
    color: "#fff",
    padding: "12px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "15px",
    fontWeight: "500",
    transition: "0.3s",
  },
  loader: {
    border: "2px solid #f3f3f3",
    borderTop: "2px solid #fff",
    borderRadius: "50%",
    width: "14px",
    height: "14px",
    animation: "spin 1s linear infinite",
  },
};

// ✅ Add loader animation keyframes
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;
document.head.appendChild(styleSheet);
